import { render, staticRenderFns } from "./footer.vue?vue&type=template&id=cb678350&scoped=true&v=2.1.45"
import script from "./footer.vue?vue&type=script&lang=js&v=2.1.45"
export * from "./footer.vue?vue&type=script&lang=js&v=2.1.45"
import style0 from "./footer.vue?vue&type=style&index=0&id=cb678350&lang=scss&scoped=true&v=2.1.45"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb678350",
  null
  
)

export default component.exports